import React from "react";
// import CountTo from "react-count-to";
import Nav from "./Nav";
import "../../assets/styles/mobile_style.scss";
class CBU extends React.Component {
  state = {
    navForm: null,
    scrollTop: null,
    topIconShow: false,
    navListShow: true,
    imageShow: false,
    num1: 550,
    num2: 7,
    num3: 260,
  };
  componentWillUnmount() {
    this.setState = () => false;
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }
  handleScroll = () => {
    //滚动条高度
    let scrollTop = document.documentElement.scrollTop; //滚动条滚动高度
    console.log(scrollTop);
    if (scrollTop >= 300) {
      this.setState({
        topIconShow: true,
        navListShow: false,
      });
    } else {
      this.setState({
        topIconShow: false,
      });
      if (scrollTop <= 50) {
        this.setState({
          navListShow: true,
        });
      }
    }
    if (scrollTop >= 2850) {
      return this.setState({
        num1: 550,
        num2: 7,
        num3: 260,
      });
    } else if (scrollTop <= 2785) {
      return this.setState({
        num1: 0,
        num2: 0,
        num3: 0,
      });
    }
  };
  // 子组件传实例this
  componentRef = (ref, type) => {
    switch (type) {
      case "nav":
        this.setState({
          navForm: ref,
        });
        break;
      default:
        break;
    }
  };
  // 滚动到页面相对应位置
  toMore = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 710;
  };
  // 显示图片部分
  toShowImage = () => {
    this.setState({
      imageShow: true,
    });
  };
  // 服务优势
  toContact = () => {
    this.props.history.push("/");
    window.localStorage.setItem("mobilePage", 4);
  };
  // 导航栏跳页面
  toPage = (index) => {
    console.log(index);
    this.props.history.push("/");
    window.localStorage.setItem("mobilePage", index);
  };
  // 返回首页
  toPageHome = () => {
    this.props.history.push("/");
  };
  // 回到顶部
  toTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };
  // 二级页面
  toSecondPage = (page) => {
    this.props.history.push("/");
    if (page === "CBU") {
      window.localStorage.setItem("mobilePage", 2);
    } else if (page === "EBU") {
      window.localStorage.setItem("mobilePage", 21);
    }
  };
  render() {
    const { topIconShow, navListShow, imageShow } =
      this.state;
    return (
      <div
        className="mobile-secondPage"
        ref={(ref) => {
          this.refDom = ref;
        }}
      >
        <div className="nav-container">
          <Nav
            componentRef={this.componentRef}
            toPage={this.toPage}
            logoClick={this.toPageHome}
            toSecondPage={this.toSecondPage}
            navListShow={navListShow}
          />
        </div>
        <div className="mobile-secondPage-container">
          <div className="CBU-1">
            <img
              src={require("@/assets/images/mobile-images/CBU-1.jpg").default}
              alt=""
            />
            <div className="area-click area-more" onClick={this.toMore} />
          </div>
          <div className="CBU-2">
            <img
              src={require("@/assets/images/mobile-images/CBU-2.jpg").default}
              alt=""
            />
          </div>
          <div className="CBU-3">
            <img
              src={require("@/assets/images/mobile-images/CBU-3.jpg").default}
              alt=""
            />
            <div
              className="area-click area-showImage"
              onClick={this.toShowImage}
            />
            <div className={`${imageShow ? "height-auto" : "displayNone"}`}>
              <img
                src={
                  require("@/assets/images/mobile-images/CBU-3-1.jpg").default
                }
                alt=""
              />
            </div>
          </div>
          <div className="CBU-4">
            <img
              src={require("@/assets/images/mobile-images/CBU-4.jpg").default}
              alt=""
            />
            <div className="area-click area-contact" onClick={this.toContact} />
          </div>
          <div className="CBU-5">
            <img
              src={require("@/assets/images/mobile-images/CBU-5.jpg").default}
              alt=""
            />
            {/* 数字统计 start*/}
            <div className="count-box count-1">
              {/* 8,100,000 */}
              14,895,759
              {/* <CountTo to={num1} speed={2000} className="count-num"></CountTo> */}
              <span className="count-text">+</span>
              <div className="count-des">车联用户<br />截止2025年06月20日</div>
            </div>
            {/* <div className="count-box count-2">
              <CountTo to={num2} speed={1000} className="count-num"></CountTo>
              <span className="count-text">亿</span>
            </div> */}
            <div className="count-box count-3">
              {/* 7,600,000 */}
              11,812,955
              {/* <CountTo to={num3} speed={2000} className="count-num"></CountTo> */}
              <span className="count-text">+</span>
              <div className="count-des">在线用户<br />截止2025年06月20日</div>
            </div>
            {/* 数字统计 end*/}
          </div>
        </div>
        {/* 返回顶部 */}
        {topIconShow ? (
          <div className="toTop" onClick={this.toTop}>
            <img src={require("@/assets/images/toTop.png").default} alt="" />
          </div>
        ) : null}
      </div>
    );
  }
}
export default CBU;
